import React from 'react'
import { useNavigate } from 'react-router'
import { SettingsItemWithIcon } from '../../Common/SettingItem/SettingItem'

export const MFASettingsRow: React.FC = () => {
  const navigate = useNavigate()

  const handleClick = () => {
    navigate('/account/settings/mfa/')
  }

  return (
    <SettingsItemWithIcon
      label='Multi-factor Authentication (MFA)'
      iconName='LineShield01'
      onClick={handleClick}
    />
  )
}
